import { EInvoicePaymentStatus } from 'views/types/invoicePayments';

export const statusPillClass = (status: string) => {
  switch (status) {
    case EInvoicePaymentStatus.COMPLETED:
      return 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300';
    case EInvoicePaymentStatus.REJECTED:
    case EInvoicePaymentStatus.CANCELLED:
    case EInvoicePaymentStatus.FAILED:
      return 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300';
    case EInvoicePaymentStatus.APPROVED:
    case EInvoicePaymentStatus.PROCESSING:
      return 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300';
    default:
      return 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300';
  }
};
